/**
 * @file LanguagePairCell.tsx
 * @brief A report table's language pair: both flags, overlapped, then the
 *        codes. The same flag pair as Session Detail and the phone's cards
 *        (DES 03-10-2026: "language pair main flags dalo like our app").
 *
 * @author DES
 * @date 03-10-2026
 */

import { LanguageFlag } from "@/components/ui/LanguageFlag";
import { formatLanguagePair } from "@/shared/utils/formatters";

function flagInput(lang?: string | null) {
  const l = lang ?? "";
  return { code: l.split("-")[0] ?? l, locale: l };
}

export function LanguagePairCell({
  source,
  target,
}: {
  source?: string | null;
  target?: string | null;
}) {
  return (
    <span className="inline-flex items-center gap-3 font-medium">
      <span className="inline-flex shrink-0 items-center" aria-hidden>
        <LanguageFlag language={flagInput(source)} className="h-7 w-7" />
        <LanguageFlag
          language={flagInput(target)}
          className="-ml-2 h-7 w-7 ring-2 ring-background"
        />
      </span>
      {formatLanguagePair(source, target)}
    </span>
  );
}
